import { Injectable } from '@angular/core';
import { HostListener } from '@angular/core' ;
import { AuthenticationService } from './index';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { HomeService } from './home.service';

@Injectable({
  providedIn: 'root'
})
export class TabCtrlService {
  tokenRefreshed: boolean = true;

  constructor(private authenticationService: AuthenticationService, private router: Router, private homeService: HomeService) { }

  tabContol(){
    this.homeService.sendMessage(true);
    this.authenticationService.setLastTimeVisited(String(new Date().getTime()));
    // localStorage.setItem("lastVisitTime" , String(new Date().getTime()));
    this.homeService.checkTokenExp().subscribe(()=>{
      console.log("deleted the session expired bearer token....");
    })
    setInterval(() => {
     if(this.authenticationService.getCurrentUser()){
        let currentUser : any = JSON.parse(this.authenticationService.getCurrentUser());
        if(currentUser.expiredTime){
          this.tokenTime = Number(currentUser.expiredTime);
        }
        this.initTimeout();
      } else {
        this.homeService.sendMessage(false);
      }
    },5000);
  }
  
  //for timeout
	timeout = environment.inactiveTimeOutMinutes;//minutes
  tokenTime = 0; 

  initTimeout(){
    if(this.timeout!=0){
      var currentDate = new Date();
      this.checkTimeout(); 
    }else{
      this.timeout = 99999999; // never timeout
      this.homeService.sendMessage(false);
    }
  }
​ 
  checkTimeout() {
    var lastVisitTime = Number(this.authenticationService.getLastVisitTime());//ocalStorage.getItem("lastVisitTime")
    var currentTime = new Date().getTime();
    if(currentTime >= lastVisitTime+this.timeout*1000*60){
        //localStorage.setItem("isTimeOut","true");
        console.log('Logging out due to inactivity.');
        this.authenticationService.setTimeOut("true");
        this.authenticationService.logout();
    }else{
       if(currentTime >= this.tokenTime){
          console.log('Logging out due to expired token.');
          this.authenticationService.logout();
       } else if(currentTime/1000 >= (this.tokenTime/1000 - (6*60))){
        this.tokenRefreshed = false;
         this.authenticationService.tokenRefresh().subscribe(
          data => {
              //console.log('Test output :' + JSON.stringify(data));  
              this.tokenRefreshed = true;
              console.log('Token refreshed'); 
          },
          error => {   
              console.log('Token is invalid - Please login again');
          });
       }
       this.authenticationService.removeTimeOut();
      //localStorage.removeItem("isTimeOut");
    }
    this.homeService.sendMessage(false);
  }

}
